const CommonUserStructure = {
    userId: "",
    name: {
      firstName: "",
      lastName: ""
    },
    imageUrl: "",
    gender: "",
    ethenic: "",
    email: "",
    password: "",
    mobileNumber: "",
    devices: [],
    dateOfBirth: "",
    address: {
        street: "",
        city: "",
        state: "",
        zipCode: "",
        country: ""
    },
  };
  
  export default CommonUserStructure;
  